module.exports = __webpack_public_path__ + "img/size6_en.366496fa.png";